module.exports = __webpack_public_path__ + "img/input-pipe.d8a1bf3e.svg";